import { trpc } from '@tencent/tpro_rmonitor_user_manager_user_role_auth';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

type IModifyRolePermissionReq = WithTypeCast<trpc.rmonitor.user_manager.IModifyRolePermissionReq>;
type IModifyRolePermissionRsp = WithTypeCast<trpc.rmonitor.user_manager.IModifyRolePermissionRsp>;
type IGetRolePermissionReq = WithTypeCast<trpc.rmonitor.user_manager.IGetRolePermissionReq>;
type IGetRolePermissionRsp = WithTypeCast<trpc.rmonitor.user_manager.IGetRolePermissionRsp>;
type IExitTenantReq = WithTypeCast<trpc.rmonitor.user_manager.IExitTenantReq>;
type IExitTenantRsp = WithTypeCast<trpc.rmonitor.user_manager.IExitTenantRsp>;

/**
 * 产品成员管理
 */
export class UserRoleService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.UserRoleService,
    });
  }

  /**
   * 添加角色权限
   */
  public async addRolePermission(req: IModifyRolePermissionReq): Promise<boolean> {
    try {
      const res: IModifyRolePermissionRsp = await this.trpcPost('AddRolePermission', req);
      return res.baseRsp?.code === 0;
    } catch (e) {
      return false;
    }
  }

  public async deleteRolePermission(req: IModifyRolePermissionReq): Promise<boolean> {
    try {
      const res: IModifyRolePermissionRsp = await this.trpcPost('DeleteRolePermission', req);
      return res.baseRsp?.code === 0;
    } catch (e) {
      return false;
    }
  }

  /**
   * 获取角色无权限的节点
   * @param req
   */
  public async getRolePermission(req: IGetRolePermissionReq): Promise<string[]> {
    try {
      const res: IGetRolePermissionRsp = await this.trpcPost('GetDeletedRolePermission', req);
      return res?.permissionIds ?? [];
    } catch (e) {
      return [];
    }
  }

  /**
   * 退出产品
   * @param req
   */
  public async exitTenant(req: IExitTenantReq, opts?: any): Promise<IExitTenantRsp> {
    try {
      const res: IExitTenantRsp = await this.trpcPost('ExitTenant', req, opts);
      return res;
    } catch (e) {
      return {};
    }
  }
}

export const userRoleService = new UserRoleService();
